<template>
  <div class="pa-4">
    <v-text-field placeholder="Url" v-model="link"></v-text-field>
    <link-preview
      :previewObject="previewObject"
      v-if="previewObject"
    ></link-preview>
  </div>
</template>
<script>
import Vue from "vue";
import LinkPreview from "./LinkPreview";

export default {
  components: { "link-preview": LinkPreview },
  props: ["setLinkData"],
  data: () => ({
    link: "",
    image: "",
    previewObject: null,
  }),
  watch: {
    async link(link) {
      await Vue.axios
        .get(`${this.$store.state.api}/post/urlPreview?link=${link}`, {
          ...this.$store.getters.requestHeaders,
        })
        .then(
          async function(res) {
            this.previewObject = res.data.result;
            this.setLinkData(link);
          }.bind(this)
        )
        .catch(function(e) {});
    },
  },
};
</script>
